<template>
  <div
    class='cm-tag'
    :class='{
      "cm-tag--is-focused": isFocused,
      [`cm-tag--${theme}`]: theme
    }'
  >
    <slot />
    {{ label || value }}
    <button
      type='button'
      class='cm-tag__close'
      @click="$emit('delete', value)"
      @focus="isFocused = true"
      @blur="isFocused = false"
    >close</button>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
    },
    value: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
      // [panda]
    }
  },

  data() {
    return { isFocused: false };
  }
};
</script>

<style lang='scss' scoped>
.cm-tag {
  display: inline-flex;
  align-items: center;
  padding: 0 0.3rem 0 1rem;
  height: 2rem;
  background: var(--bg-2);
  border-radius: 100px;
  white-space: nowrap;

  &--is-focused {
    color: var(--fg-2);
  }

  &__close {
    appearance: none;
    background: none;
    border: none;
    width: 1.5rem;
    height: 1.5rem;
    padding: 0.25rem;
    font-size: 0.5rem;
    font-family: $ff_icon;
    color: var(--fg-2);

    &:focus {
      outline: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/tag.vue?2d87b986